/**
 * Replace {organization_name} placeholder in question text.
 */
export const replaceOrganizationName = (text: string, organizationName: string): string => {
  return text.replace(/{organization_name}/g, organizationName)
}

/**
 * Replace all placeholders ({first_name}, {organization_name}) in manager-facing text.
 */
export const replaceManagerPlaceholders = (text: string, directReportName: string, organizationName: string): string => {
  return text
    .replace(/{first_name}/g, directReportName)
    .replace(/{organization_name}/g, organizationName)
}

/**
 * Format a 0-10 score as a percentage string.
 */
export const formatScore = (score: number): string => {
  return ((score / 10) * 100).toFixed(2) + ' %'
}
